"use client";

import { unit } from '@ant-design/cssinjs';
const getHorizontalStyle = token => {
  const {
    componentCls,
    motionDurationSlow,
    horizontalLineHeight,
    colorSplit,
    lineWidth,
    lineType,
    itemPaddingInline
  } = token;
  return {
    ["".concat(componentCls, "-horizontal")]: {
      lineHeight: horizontalLineHeight,
      border: 0,
      borderBottom: "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(colorSplit),
      boxShadow: 'none',
      '&::after': {
        display: 'block',
        clear: 'both',
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      ["".concat(componentCls, "-item, ").concat(componentCls, "-submenu")]: {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'bottom',
        paddingInline: itemPaddingInline
      },
      ["> ".concat(componentCls, "-item:hover,\n        > ").concat(componentCls, "-item-active,\n        > ").concat(componentCls, "-submenu ").concat(componentCls, "-submenu-title:hover")]: {
        backgroundColor: 'transparent'
      },
      ["".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title")]: {
        transition: ["border-color ".concat(motionDurationSlow), "background ".concat(motionDurationSlow)].join(',')
      },
      // ===================== Sub Menu =====================
      ["".concat(componentCls, "-submenu-arrow")]: {
        display: 'none'
      }
    }
  };
};
export default getHorizontalStyle;